import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import RenderOnRole from "../../../Utilities/RenderOnRole";
import UserService from "../../../services/UserService";

const KlantDetailsSection = ({ klant }) => {
    const { t } = useTranslation();

    const isEmployee = useMemo(() => UserService.hasRole(["SD_Medewerker", "Administrator"]), []);

    const details = useMemo(() => [
        { label: t('customers.debtorNumber'), value: klant?.debiNr ?? "", visibleForEmployee: true, visibleForCustomer: false },
        { label: t('customers.relationNumber'), value: klant?.relaNr ?? "", visibleForEmployee: true, visibleForCustomer: false },
        { label: t('customers.kvkNumber'), value: klant?.kvknum ?? "", visibleForEmployee: true, visibleForCustomer: true },
        { label: t('customers.vatNumber'), value: klant?.btwnum ?? "", visibleForEmployee: true, visibleForCustomer: true },
        { label: t('customers.gln'), value: klant?.gln ?? "", visibleForEmployee: true, visibleForCustomer: true },
        { label: t('customers.erp'), value: klant?.erp ?? "", visibleForEmployee: true, visibleForCustomer: true },
    ], [klant, t]);

    const visibleDetails = useMemo(() => {
        return details.filter(detail => isEmployee ? detail.visibleForEmployee : detail.visibleForCustomer);
    }, [details, isEmployee]);

    const renderDetailItems = () => {
        return visibleDetails.map((detail, index) => (
            <div key={`detail-${index}`} className="col-span-1" style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                <label style={{ fontWeight: "600", color: "#374151", fontSize: "0.875rem" }}>{detail.label}</label>
                <input
                    className="filter-input"
                    type="text"
                    readOnly
                    value={detail.value}
                    style={{ backgroundColor: "#e5e7eb", color: "#6b7280", cursor: "not-allowed" }}
                />
            </div>
        ));
    };

    return (
        <div className="filter-bar">
            <h3>{t('customers.customerDetails')}</h3>
            <div className={`grid ${isEmployee ? "grid-cols-2" : "grid-cols-1"} gap-4`}>
                {renderDetailItems()}
            </div>
        </div>
    );
};

export default KlantDetailsSection;
